module.exports = __webpack_public_path__ + "img/deskalo.f1564b6f.png";